"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("./shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Input = _styledComponents["default"].input.withConfig({
  shouldForwardProp: _shared.shouldForwardProp
}).withConfig({
  displayName: "input__Input",
  componentId: "sc-1myz9cf-0"
})(["", ";"], _shared.defaultSystemProps);

var propTypes = {
  // Boolean that determines if input gets focused when the page loads
  autoFocus: _propTypes.bool
};
Input.propTypes = propTypes;
Input.displayName = "Primitives.Input";
var _default = Input;
exports["default"] = _default;